import React from 'react';
import { Link } from 'react-router-dom';
import { GUIAS } from '../data/guias';
import { usePageMeta } from '../utils/seo';
import GuideCard from '../components/GuideCard';
// Estilos base (.nvh-*) e dos cartões vêm de Home.css.
import './Home.css';
import './Guia.css';

const Guias = () => {
  usePageMeta({
    title: 'Guias práticos de Direito Criminal',
    description:
      'Guias práticos e informativos: o que fazer em caso de intimação para depor, prisão em flagrante, busca e apreensão e citação em processo criminal.'
  });

  return (
    <div className="nvh nvg">
      <section className="nvg-hero">
        <div className="nvh-wrap">
          <nav className="nvg-breadcrumb" aria-label="Caminho">
            <Link to="/">Início</Link>
            <span aria-hidden="true">›</span>
            <span aria-current="page">Guias</span>
          </nav>
          <h1>Guias práticos</h1>
          <p className="nvg-subtitle">
            Orientações informativas para situações que costumam pegar as pessoas de surpresa. Cada caso tem
            particularidades: em caso de dúvida, fale com um advogado.
          </p>
        </div>
      </section>
      <section className="nvh-section nvh-ivory">
        <div className="nvh-wrap">
          <div className="nvh-guides">
            {GUIAS.map((guia) => (
              <GuideCard key={guia.slug} guia={guia} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Guias;
